module.exports = __webpack_public_path__ + "static/media/Logo.7fea2245.png";